import { Component, OnInit } from '@angular/core';
import { ButtonGroupBaseFilterDirective } from '../button-group-base-filter.directive';

@Component({
    selector: 'portal-button-group-multi',
    templateUrl: './button-group-multi.component.html',
    standalone: false
})
export class ButtonGroupMultiComponent extends ButtonGroupBaseFilterDirective implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
